module.exports = __webpack_public_path__ + "static/media/home-alt.ad70cdc6.svg";